/**
 * Exchange
 */
class Exchange {
    constructor() {
        this._locked = false;
        this._confirmShowBlocked = true;
        this._confirmationShowButton = $('.confirmation-show-btn');
        this._loadingSpinner = $('.loading-spinner');

        this._errorMessageContainer = $('.exchange-error-container');
        this._errorMessage = $('.exchange-error-message');

        this._minExchangeRangeMessageContainer = $('.min-exchange-range-container');
        this._minExchangeRangeMessageMessage = $('.min-exchange-range-message');

        this._sendAmount = $('#send_amount');
        this._receiveAmount = $('#receive_amount');
        this._address = $('#address');

        this._exchangeRange = null;
        this._exchangeRangeMessage = null;
        this.__loadExchangeData();

        this._typingTimer;
        this._doneTypingInterval = 1500;

        this._confirmedSendAmout = null;
        this._confirmedFromCurrency = null;
        this._confirmedToCurrency = null;
        this._confirmedAddress = null;
    }

    _lock() {
        this._locked = true;
    }

    _unlock() {
        this._locked = false;
    }

    _blockShowConfirm() {
        var that = this;
        that._confirmShowBlocked = true;
        if(!that._confirmationShowButton.hasClass("disabled")) {
            that._confirmationShowButton.addClass("disabled");  
        }
    }

    _unblockShowConfirm() {
        var that = this;
        that._confirmShowBlocked = false;
        that._confirmationShowButton.removeClass("disabled");  
    }

    _getParsedSendAmout() {
        var that = this;
        return parseFloat(that._sendAmount.val().replace(',', '.'));
    }

    __loadExchangeData() {
        var that = this;
        that._lock();
        that._showLoading();

        that._showErrorMessage(null);
        that._receiveAmount.val(0);
        that._setExchangeRange(null);
        that._hideExchangeRangeMessage();

        that._loadExchangeRange(function (result) {
            var that = this;
            if (!result) {
                that._hideLoading();
                that._unlock();
                return;
            }

            that._estimateExchangeAmount(function (result) {
                var that = this;
                that._hideLoading();
                that._unlock();
                return;
            });
        });
    }

    _loadExchangeRange(callback) {
        var that = this;

        $.ajax({
            url: "/exchange/range",
            dataType: "json",
            data: {
                from_currency: $('#from_currency').val(),
                to_currency: $('#to_currency').val(),
            },
            success: function (data) {
                if (data.error !== undefined) {
                    that._showErrorMessage(data.error);

                    if (typeof callback === 'function') callback.apply(that, [false]);
                    return;
                }

                that._setExchangeRange(data);
                that._setExchangeRangeMessage(data);
                that._showExchangeRangeMessage();

                if (typeof callback === 'function') callback.apply(that, [true]);
                return;
            },
            error: function (data) {
                that._showErrorMessage("Error");

                if (typeof callback === 'function') callback.apply(that, [false]);
                return;
            }
        });
    }

    _showLoading() {
        this._blockShowConfirm();
        this._loadingSpinner.show();
    }

    _hideLoading() {
        this._loadingSpinner.hide();
        this._unblockShowConfirm();
    }

    _validateSendAmount() {
        var that = this;
        if (that._sendAmount.val() == "") {
            return false;
        }

        var sendAmout = that._getParsedSendAmout();
        var valid = !isNaN(sendAmout) && that._exchangeRange !== null && sendAmout >= that._exchangeRange.minAmount && (that._exchangeRange.maxAmount === null || sendAmout <= that._exchangeRange.maxAmount);
        if (!valid) {
            if (!that._sendAmount.hasClass("field-error")) {
                that._sendAmount.addClass("field-error");
            }

            return false;
        }

        that._sendAmount.removeClass("field-error");
        return true;
    }

    //TODO: needs to be implemented real wallet address validation
    _validateAddress() {
        var that = this;

        var valid = that._address.val().trim() != "";
        if (!valid) {
            if (!that._address.hasClass("field-error")) {
                that._address.addClass("field-error");
            }

            return false;
        }

        that._address.removeClass("field-error");
        return true;
    }

    _setExchangeRange(data) {
        if (data === null || data.range === undefined) {
            this._exchangeRange = null;
            return;
        }

        this._exchangeRange = data.range;
    }

    _setExchangeRangeMessage(data) {
        if (data === null || data.message === undefined) {
            this._exchangeRangeMessage = "Error1";
            return;
        }

        this._exchangeRangeMessage = data.message;
    }

    _showExchangeRangeMessage() {
        this._minExchangeRangeMessageMessage.html(this._exchangeRangeMessage);
        this._minExchangeRangeMessageContainer.show();
    }

    _hideExchangeRangeMessage() {
        this._minExchangeRangeMessageMessage.html("");
        this._minExchangeRangeMessageContainer.hide();
    }

    _showErrorMessage(error) {
        if (error == null) {
            this._errorMessage.html("");
            this._errorMessageContainer.hide();
            return;
        }

        this._errorMessage.html(error);
        this._errorMessageContainer.show();
    }

    _estimateExchangeAmount(callback) {
        var that = this;
        if (!that._validateSendAmount()) {
            if (typeof callback === 'function') callback.apply(that, [false]);
            return;
        }

        $.ajax({
            url: "/exchange/estimated/amount",
            dataType: "json",
            data: {
                from_currency: $('#from_currency').val(),
                to_currency: $('#to_currency').val(),
                send_amount: that._getParsedSendAmout(),
            },
            success: function (data) {
                if (data.error !== undefined) {
                    that._showErrorMessage(data.error);

                    if (typeof callback === 'function') callback.apply(that, [false]);
                    return;
                }

                if (data.estimatedAmount !== undefined) {
                    that._receiveAmount.val(data.estimatedAmount);
                }

                if (typeof callback === 'function') callback.apply(that, [true]);
                return;
            },
            error: function (data) {
                that._showErrorMessage("Error");

                if (typeof callback === 'function') callback.apply(that, [false]);
                return;
            }
        });
    }

    currencyChange() {
        var that = this
        if (that._locked) return;

        that.__loadExchangeData();
    }

    switchCurrencies() {
        var that = this
        if (that._locked) return;

        var fromElement = $('#from_currency').clone();
        fromElement.attr('id', 'to_currency');

        var toElement = $('#to_currency').clone();
        toElement.attr('id', 'from_currency');

        $('#from_currency').replaceWith(toElement);
        $('#to_currency').replaceWith(fromElement);

        that.__loadExchangeData();
    }

    resetTypingTimer() {
        var that = this;
        clearTimeout(that._typingTimer);
        that._blockShowConfirm();
        that._typingTimer = setTimeout(function () {
            that.__loadExchangeData()
        }, that._doneTypingInterval);
    }

    clearTypingTimer() {
        var that = this;
        that._blockShowConfirm();
        clearTimeout(that._typingTimer);
    }

    showCreate() {
        var that = this;
        if (that._locked) return;
        that.__loadExchangeData();
        $('.exchange-confirm').hide();
        $('.exchange-loading').hide();
        $('.exchange-create').show();
        this._confirmedSendAmout = null;
        this._confirmedFromCurrency = null;
        this._confirmedToCurrency = null;
        this._confirmedAddress = null;
    }

    showConfirm() {
        var that = this;
        if (that._confirmShowBlocked) {
            return;
        }
        if (!that._validateAddress()) {
            return;
        }

        if (!that._validateSendAmount()) {
            return;
        }

        this._confirmedSendAmout = that._getParsedSendAmout();
        this._confirmedFromCurrency = $('#from_currency').val();
        this._confirmedToCurrency = $('#to_currency').val();
        this._confirmedAddress = that._address.val();

        $("#send_amount_confirmed").html(that._confirmedSendAmout + " " + that._confirmedFromCurrency.toUpperCase());
        $("#receive_amount_confirmed").html("&#8776;" + that._receiveAmount.val() + " " + that._confirmedToCurrency.toUpperCase());
        $("#address_confirmed").html(that._confirmedAddress);
        $('.exchange-create').hide();
        $('.exchange-loading').hide();
        $('.exchange-confirm').show();
    }

    confirm() {
        var that = this;
        if (that._confirmedSendAmout === null || that._confirmedFromCurrency === null || that._confirmedToCurrency === null || that._confirmedAddress === null) {
            return;
        }

        $('.exchange-create').hide();
        $('.exchange-confirm').hide();
        $('.exchange-loading').show();

        $.ajax({
            type: "POST",
            url: "/exchange/transaction/create",
            dataType: "json",
            data: {
                from_currency: that._confirmedFromCurrency,
                to_currency: that._confirmedToCurrency,
                send_amount: that._confirmedSendAmout,
                address: that._confirmedAddress,
            },
            success: function (data) {
                if (data.error !== undefined) {
                    that.showCreate();
                    that._showErrorMessage(data.error);
                    return;
                }
                if (data.id === undefined) {
                    that.showCreate();
                    that._showErrorMessage("Error");
                    return;
                }

                window.location.href = '/exchange/transaction/status/' + data.id;
            },
            error: function (data) {
                that.showCreate();
                that._showErrorMessage("Error");
            }
        });
    }
}

export { Exchange }